import { OrderLineReducer } from './order-line.reducer';

export const reducers = OrderLineReducer;
